import { FormResponseErrorType } from '../enums/FormResponseErrorType';

export default class FormError extends Error {
  public response: { data: { errorType: string } };

  constructor(errorType: FormResponseErrorType) {
    super();
    this.response = {
      data: {
        errorType,
      },
    };
  }
}
